import type { WebJobApiResponse, WebJobFilter, WebJobsState } from "@/features/admin/types/config.types";
import { createAsyncThunk, createSlice, type PayloadAction } from "@reduxjs/toolkit";
import { configService } from "../services/configService";

export const fetchWebJobs = createAsyncThunk<
  WebJobApiResponse[],
  string,
  { rejectValue: string }
>(
  "webJobs/fetchWebJobs",
  async (timeZone, { rejectWithValue }) => {
    try {
      const res=await configService.GetAllWebJobs(timeZone);
      return res
    } catch (err: any) {
      return rejectWithValue(
        err?.response?.data?.message || "Failed to fetch web jobs"
      );
    }
  })


const initialState: WebJobsState = {
  jobs: [],
  selectedFilter: "ALL",
  loading: false,
  error: ""
};


const webJobsSlice = createSlice({
  name: "webJobs",
  initialState,
  reducers: {
    setSelectedFilter(state, action: PayloadAction<WebJobFilter>) {
      state.selectedFilter = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchWebJobs.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(fetchWebJobs.fulfilled, (state, action) => {
        state.loading = false;
        state.jobs = action.payload;
      })
      .addCase(fetchWebJobs.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  }
});

export const { setSelectedFilter } = webJobsSlice.actions;
export default webJobsSlice.reducer;
